import { DetectorModes } from "types/createDetector";
import { UserType } from "types/users";

import { getConfig } from "./config";

const config = getConfig();
// TODO: We need to clean this document, remove unused constants and double check ones that could be in other places.

// ------- Constants for User status --------
export enum UserStatus {
  ACTIVE = "ACTIVE", // Currently on the labeling page, working
  BROWSER_CLOSED = "SESSION-CLOSED", // Closed browser or logged out
  IDLE = "IDLE", // Has the labeling page open, but waiting for imagequeries
  INACTIVE = "INACTIVE", // Labeling page is open, but toggled the "inactive" switch
}

// ------- Labels URL PARAMS -------
export const BOUNDING_BOXES = "BOUNDING_BOXES";
export const BINARY_CLASSIFICATION = "BINARY_CLASSIFICATION";

// ------- Constants for UI implementations ----------
export const HEADER_MENU_HEIGHT = 48;
export const COMPANY_INFO = {
  name: "Groundlight AI",
  logoUri: "/static/positronix-logo.png",
};

// ------------- Detectors Details Page Constants --------------//
export const DETECTOR_DETAILS_REFRESH_TIME = 10;
export const DEFAULT_PATIENCE_TIME = 30;

// ------------- Posichecks Constants --------------//
export const AWAITING = "Awaiting";
export const INITIAL_PLACEHOLDER = "INITIAL_PLACEHOLDER";

// ------------- useFetch Constants --------------//
export const MAX_RETRIES = 3;
export const NO_RETRIES = 0;
export const RETRY_DELAY = 1000;

// ------------- Annotations Image Contants --------------//
export const MAX_ROIS_TO_DISPLAY = 5;

// ------------- Explore Page Contants --------------//
export const DEFAULT_DETECTOR_GROUP = "Explore";
export const DEFAULT_EXPLORE_DETECTOR_NAME = "WEBCAM (Explore)";
export const EXPLORE_PAGE_REFRESH_TIME = 2;

// -------------- App environment constants --------------//
export const PRODUCTION = "production";
export const REVIEW = "review";
export const INTEG = "integ";
export const USSLG = "usslg";

// Query param that bypasses the usslg admin block on the detector list and global review queue.
export const SHOW_ALL_PARAM = "show_all";

// -------------- EXTERNAL URLS --------------//
export const SDK_DOCS_URL = "https://code.groundlight.ai/python-sdk/docs/getting-started";
export const SDK_API_TOKEN_URL = "https://code.groundlight.ai/python-sdk/docs/getting-started/api-tokens";
export const SDK_BEGINNER_TUTORIAL_URL =
  "https://www.groundlight.ai/guides/beginner-tutorial-computer-vision-python-sdk";

// -------------- Service Worker --------------//
export const AUTH_REDIRECT_URL = config.JANZU_URL;
export const SERVICE_WORKER_UPDATE_INTERVAL = 60000; // every minute

// -------------- Review Page constants --------------//
// This is how long labelers have to press Undo
export const TIME_TO_UNDO_LABEL = 3000;

// --------- COUNT mode constants ------------------
export const DEFAULT_MAX_COUNT = 10;
export const MAX_ANNOTATIONS_PER_IQ = 25;

// --------- TEXT mode constants ------------------
export const TEXT_DEFAULT_MAX_LENGTH = 250;

// ---------- Google Analytics Constants ------------
export const GA_MEASUREMENT_ID = "G-5TS7NJJQQQ";
export const PROD_GA_USER_COOKIE_NAME = "gl_user";
export const INTEG_GA_USER_COOKIE_NAME = "integ_gl_user";

// --------- Detector constants ------------------
export const STABLE_DETECTOR_MODES: DetectorModes[] = [DetectorModes.BINARY];
export const DETECTOR_MODES_WITH_BOUNDING_BOXES = [DetectorModes.COUNT];
export const DETECTOR_MODE_TO_ABBREVIATED_NAME: Record<DetectorModes, string> = {
  [DetectorModes.COUNT]: "count",
  [DetectorModes.MULTICHOICE]: "mult.choice",
  [DetectorModes.BINARY]: "binary",
  [DetectorModes.TEXT_RECOGNITION]: "text",
  [DetectorModes.BOUNDING_BOX]: "bounding box",
};
export const DETECTOR_QUERY_LENGTH_LIMIT = 300;

export const MAX_DETECTOR_NAME_LENGTH = 100;
export const MAX_DETECTOR_NAME_LENGTH_ERROR = "Detector name is too long (max 100 characters).";

// --------- Groundlight links ------------------
export const GROUNDLIGHT_SUPPORT_EMAIL = "axon-vision-support@axon.com";

// --------- User types ------------------
export const LABELER_USER_TYPES: UserType[] = [UserType.Labeler, UserType.Manager, UserType.LabelerAI];
